/** Mirrors `AddCompetitorsRequest` (1–20 handles) on the API. */
export const RESEARCH_MAX_HANDLES = 20;

/** Loose client-side check; the API normalises `@`, case, and profile URLs. */
export const IG_HANDLE_RE = /^@?[A-Za-z0-9._]{1,30}$/;

/**
 * Mirror of the API's `normalize_handle`: `@Some.Handle`, mixed case, or a
 * profile URL → `some.handle`; `null` when it can't be a valid IG handle.
 */
export function normalizeHandle(raw: string): string | null {
  let h = raw.trim().replace(/^@/, '').toLowerCase();
  const m = h.match(/instagram\.com\/([a-z0-9._]+)/);
  if (m?.[1]) h = m[1];
  h = h.replace(/\/+$/, '');
  return IG_HANDLE_RE.test(h) ? h : null;
}

/** Poll the overview while a research run is in flight. */
export const RESEARCH_POLL_MS = 15_000;

/** Top posts shown per competitor in the table. */
export const RESEARCH_TOP_POSTS = 3;
